import React, { Fragment, useState, useEffect, useLayoutEffect } from "react"
import CampaignBanner from "./components/CampaignBanner"
import ReactMarkdown from "react-markdown"
import Col from "react-bootstrap/lib/Col"
import Row from "react-bootstrap/lib/Row"
import AlertModalWithBody from "../../../ui-components/AlertModalWithBody"
import isValidHttpUrl from "../../../utils/urlHelper"
import { GetAllCampaigns } from "../../../apis/AdvertisingAPI";

export default function CampaignsBannerHorizontalList(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { userToken, latitude, longitude } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  const [size, setSize] = useState([0, 0])
  const [media, setMedia] = useState(undefined)
  const [state, setState] = useState({
    campaigns: [],
    campaignModalOpen: false,
  })

  // -------------------------------------
  // Effects
  // -------------------------------------

  useEffect(() => {
    fetchCampaigns()
  }, [])

  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight])
    }
    window.addEventListener("resize", updateSize)
    updateSize()
    return () => window.removeEventListener("resize", updateSize)
  }, [])

  // when fetchCampaigns returns or the page is resized, compute the size of the media
  useEffect(() => {
    setMediaSize()
  }, [state, size])


  // -------------------------------------
  // Component functions
  // -------------------------------------

  const fetchCampaigns = async function() {
    try {
      const campaigns = await GetAllCampaigns(latitude, longitude, userToken) || []

      campaigns.forEach((campaign) => {
            // sort breakpoints to match media queries the right way later
            campaign.cover_images?.sort((a, b) => a.breakpoint - b.breakpoint)
            campaign.preview_images?.sort((a, b) => a.breakpoint - b.breakpoint)
          })

      setState({ ...state, campaigns: campaigns })

    } catch (error) {
      console.log(error)
    }
  }

  function setMediaSize() {
    if (matchMedia !== undefined && state.campaigns.length > 0) {
      let campaign = state.campaigns[0]
      let media = {
        preview: campaign?.preview_images[0]?.url,
        cover: campaign?.cover_images[0]?.url,
      }
      for (let preview of campaign?.preview_images || []) {
        if (
          preview.breakpoint &&
          window.matchMedia(`(max-width: ${preview.breakpoint}px)`).matches
        ) {
          media.preview = preview.url
          break
        }
      }
      for (let cover of campaign?.cover_images || []) {
        if (
          cover.breakpoint &&
          window.matchMedia(`(max-width: ${cover.breakpoint}px)`).matches
        ) {
          media.cover = cover.url
          break
        }
      }
      if (media.preview || media.cover) setMedia(media)
    }
  }

  function showCampaignModal(campaign) {
    if (isValidHttpUrl(campaign.url)) {
      window.open(campaign.url, "_blank")
    } else {
      setState({ ...state, campaign: campaign, campaignModalOpen: true })
    }
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  const campaign = state.campaigns[0]

  // -------------------------------------

  return (
    <Fragment>
      <AlertModalWithBody
        show={state.campaignModalOpen}
        onHide={() => setState({ ...state, campaignModalOpen: false })}
        onConfirm={() => setState({ ...state, campaignModalOpen: false })}
        title={campaign?.title || ""}
        closeLabel={I18n.t("pages.locations.venues.close_label")}
        isTiny={false}
      >
        <div style={{ fontSize: 18, fontWeight: 500 }}>
          {campaign?.subtitle}
        </div>
        <img
          src={media?.cover}
          style={{ width: "100%", maxWidth: 800, marginTop: 20 }}
        />
        <Row style={{ paddingTop: "20px" }}>
          <Col sm={12}>
            <ReactMarkdown
              renderers={{
                link: (props) => (
                  <a href={props.href} target="_blank">
                    {props.children}
                  </a>
                ),
              }}
            >
              {campaign?.description || ""}
            </ReactMarkdown>
          </Col>
        </Row>
      </AlertModalWithBody>

      {campaign && (
        <CampaignBanner
          campaignTitle={campaign.title}
          campaignImageUrl={media?.preview}
          onClick={() => showCampaignModal(campaign)}
        />
      )}
    </Fragment>
  )
}
